import { render, staticRenderFns } from "./assessAnswer.vue?vue&type=template&id=018744ca&scoped=true"
import script from "./assessAnswer.vue?vue&type=script&lang=js"
export * from "./assessAnswer.vue?vue&type=script&lang=js"
import style0 from "./assessAnswer.vue?vue&type=style&index=0&id=018744ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018744ca",
  null
  
)

export default component.exports